(() => {
  const init = () => document.querySelectorAll('.vf-page:not([data-ready])').forEach(page => {
    page.dataset.ready = 'true';
    const slides = page.querySelector('.vf-slides');
    const dots = [...page.querySelectorAll('[data-vf-slide]')];
    let current = 0;
    const move = n => slides.scrollTo({left: ((n + dots.length) % dots.length) * slides.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    dots.forEach((dot, n) => dot.addEventListener('click', () => move(n)));
    page.querySelector('[data-vf-prev]').addEventListener('click', () => move(current - 1));
    page.querySelector('[data-vf-next]').addEventListener('click', () => move(current + 1));
    slides.addEventListener('scroll', () => {current = Math.round(slides.scrollLeft / slides.clientWidth); dots.forEach((d,n)=>d.setAttribute('aria-current', String(n === current)));}, {passive:true});
    slides.addEventListener('keydown', e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(current+(e.key==='ArrowRight'?1:-1));}});
    const floating = page.querySelector('.vf-floating');
    new IntersectionObserver(entries => floating.classList.toggle('is-hidden', entries[0].isIntersecting), {threshold:0.1}).observe(page.querySelector('.vf-buy-copy'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load',init);
})();
